import React from "react";
import './quiz.scss';
// import NewAssessment from "./new-assessment/new-assessment";
import SchoolApi from "../../apis/school";
import ClickerFlowPractice from "./quiz-list/quiz-list";
import ToasterComponent from "../common/cw-toaster-component/cw-toaster-component";
import ClassworkHeader from "./my-classwork-header/my-classwork-header";
import NewQuiz from "./new-quiz/new-quiz";


class Quiz extends React.Component {


    state = {
        schoolsList: [],
        showHeader : true
    }

    hideNewAssessment() {
        this.setState({ showNewAssessment: false })
    }

    showSuccessMessage() {
        this.hideNewQuiz()
        this.showToaster('info', "Quiz Created successfully")
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 8000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onClickNewHomeWork() {
        this.setState({ showNewQuiz: true })
    }

    hideNewQuiz() {
        this.setState({ showNewQuiz: false })
    }

    

    hideHeader() {
        this.setState({showHeader : false})
    }




    render() {

        if (this.state.showNewQuiz) {
            return <NewQuiz delegate={this} />
        }

        return (
            <div className="quiz">
                {
                    this.state.showHeader ? <ClassworkHeader delegate={this} showActiveFilter={this.state.showActiveFilter} /> : <></>
                }
                
                <ClickerFlowPractice delegate={this} />
                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
            </div>
        )
    }
}


export default Quiz;